import { useNavigate } from 'react-router-dom'
import Hero from '../components/Hero'
import UploadDropzone from '../components/UploadDropzone'
import { useState } from 'react'
import { uploadImage } from '../lib/api'

export default function Home() {
  const navigate = useNavigate()
  const [isUploading, setIsUploading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleFile(file: File) {
    setIsUploading(true)
    setError(null)
    try {
      const { id } = await uploadImage(file)
      navigate(`/scan/${id}`)
    } catch (e: any) {
      setError(e?.message ?? 'Algo se rompió. Intenta otra vez.')
      setIsUploading(false)
    }
  }

  return (
    <main className="min-h-screen flex flex-col">
      <header className="px-6 md:px-12 py-6 flex items-center justify-between">
        <a href="/" className="font-mono text-sm tracking-tight text-[var(--color-fg)]">
          eigen-splat
        </a>
        <nav className="flex gap-6 text-sm text-[var(--color-muted)]">
          <a href="/about" className="hover:text-[var(--color-fg)] transition">how</a>
          <a
            href="https://github.com/Theovia/eigen-splat"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[var(--color-fg)] transition"
          >
            github
          </a>
        </nav>
      </header>

      <Hero />

      <section className="px-6 md:px-12 py-16 flex flex-col items-center gap-6">
        <UploadDropzone onFile={handleFile} disabled={isUploading} />
        {isUploading && (
          <p className="text-sm text-[var(--color-muted)]">
            uploading + reconstructing... ~30-60s
          </p>
        )}
        {error && <p className="text-sm text-red-400">{error}</p>}
      </section>

      <section className="px-6 md:px-12 py-20 max-w-4xl mx-auto w-full">
        <h2 className="text-2xl md:text-3xl font-medium mb-8">how it works</h2>
        <div className="grid md:grid-cols-3 gap-8 text-sm">
          {[
            { n: '01', t: 'snap', d: 'one photo. front-facing or any object.' },
            { n: '02', t: 'reconstruct', d: 'feed-forward gaussian splatting via Replicate.' },
            { n: '03', t: 'rotate + share', d: 'open the link, drag to rotate. embed anywhere.' },
          ].map((s) => (
            <div key={s.n} className="border-l-2 border-[var(--color-accent)] pl-4">
              <div className="font-mono text-xs text-[var(--color-muted)] mb-2">{s.n}</div>
              <div className="text-[var(--color-fg)] font-medium mb-1">{s.t}</div>
              <div className="text-[var(--color-muted)]">{s.d}</div>
            </div>
          ))}
        </div>
      </section>

      <footer className="mt-auto px-6 md:px-12 py-8 text-xs text-[var(--color-muted)] border-t border-white/5 flex justify-between">
        <span>built by Eigen Atlas</span>
        <span className="font-mono">v0.1</span>
      </footer>
    </main>
  )
}
